import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Country } from '@shared/models/location.model';
import { Observable, map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private http = inject(HttpClient);
  private readonly url = 'assets/data/countries.json';

  private countries$ = this.http
    .get<Country[]>(this.url)
    .pipe(shareReplay(1));

  getCountries(): Observable<Country[]> {
    return this.countries$;
  }

  getCountryIso2ByName(countryName: string): Observable<string | null> {
    return this.countries$.pipe(
      map(countries =>
        countries.find(
          country => country.name.toLowerCase() === countryName.toLowerCase()
        )?.iso2 ?? null
      )
    );
  }

  getCountryNameByIso2(iso2: string): Observable<string | null> {
    return this.countries$.pipe(
      map(countries =>
        countries.find(
          country => country.iso2.toLowerCase() === iso2.toLowerCase()
        )?.name ?? null
      )
    );
  }
}
